export default __webpack_public_path__ + "static/media/logo-ampersand.87a0b376.svg";